type SVGProps = {
  color?: string;
  width?: string | number;
  height?: string | number;
  className?: string;
};

const Cup = ({ color, width, height, className }: SVGProps) => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    width={width}
    height={height}
    viewBox='0 0 24 24'
  >
    <path
      fill={color || '#000'}
      fillRule='nonzero'
      d='M11.25 19.5H9v-.75a.75.75 0 0 1 .75-.75h1.5v-4.046a6.003 6.003 0 0 1-4.448-2.956A3.75 3.75 0 0 1 3 7.25v-1.5A.75.75 0 0 1 3.75 5H6V3.75A.75.75 0 0 1 6.75 3h10.5a.75.75 0 0 1 .75.75V5h2.25a.75.75 0 0 1 .75.75v1.5a3.75 3.75 0 0 1-3.802 3.748 6.003 6.003 0 0 1-4.448 2.956V18h1.5a.75.75 0 0 1 .75.75v.75h-2.25 4.5a.75.75 0 1 1 0 1.5H6.75a.75.75 0 1 1 0-1.5h4.5zM16.5 5.75V4.5h-9V8a4.5 4.5 0 1 0 9 0V5.75zM18 8v1.372a2.25 2.25 0 0 0 1.5-2.122V6.5H18V8zM6 8V6.5H4.5v.75c0 .98.626 1.813 1.5 2.122V8z'
    />
  </svg>
);

export default Cup;
